import constants from "src/utils/constants/contants";
import enums from "src/utils/constants/enums";

export default {
  constants,
  enums,
  loadingMessages: constants.LOADING_MESSAGES
};
